import React, { ComponentType } from 'react'
import { scrollToApplicationForm } from '@shared/components/forms/application/cross'
import cx from 'classnames'

import ArrowIcon from './icons/arrow.svg'

import styles from './style.module.scss'

interface Props {
	title: string | React.ReactNode
	hint?: string | React.ReactNode
	mainTitle?: string | React.ReactNode
	rateMode: 'pledge' | 'car'
	customBannerItems?: string[]
	customPercent?: string
	points: {
		IconSvg: ComponentType<any>
		title: string
		text: string
	}[]
}

const RatePledge = ({ percent = '13,9' }: { percent?: string }) => (
	<div className={styles.rateWrapper}>
		<div className={styles.ratePercentBackground}>%</div>
		<div className={styles.rateContent}>
			<div>
				<h2>Ставка от {percent} %</h2>
				<h3 className='mt-s'>
					Что влияет на величину
					<br />
					процентной ставки
				</h3>
			</div>
			<div className={styles.ratePoints}>
				{['Кредитная история заёмщика', 'Наличие залога', 'Возможность подтверждения дохода'].map(
					(item) => (
						<div key={item} className={styles.ratePoint}>
							<div className={styles.rateIcon}>
								<ArrowIcon />
							</div>
							<h4>{item}</h4>
						</div>
					)
				)}
			</div>
		</div>
	</div>
)

const RateCar = () => (
	<div className={styles.rateWrapper}>
		<div className={styles.ratePercentBackground}>%</div>
		<div className={styles.rateContent}>
			<div>
				<h2>Вам доступны лучшие условия</h2>
				<h4 className='mt-s'>
					<span style={{ cursor: 'pointer' }} onClick={scrollToApplicationForm}>
						Получить кредит сейчас
					</span>
				</h4>
			</div>
			<div className={styles.ratePoints}>
				{[
					'Пользуйтесь автомобилем',
					'ПТС остаётся у вас',
					'Для заявки только паспорт и СТС',
					'Низкая ставка от 4,9% годовых',
					'Без подтверждения дохода и поручителей',
					'Одобрение в день подачи заявки',
				].map((item) => (
					<div key={item} className={styles.ratePoint}>
						<div className={styles.rateIcon}>
							<ArrowIcon />
						</div>
						<h5>{item}</h5>
					</div>
				))}
			</div>
		</div>
	</div>
)

export const CustomCreditRate = ({
	items,
	title,
	subtitle,
}: {
	items: string[]
	title: string | React.ReactNode
	subtitle: string | React.ReactNode
}) => (
	<div className={styles.rateWrapper}>
		<div className={styles.ratePercentBackground}>%</div>
		<div className={styles.rateContent}>
			<div>
				<h2>{title}</h2>
				<h4 className='mt-s'>{subtitle}</h4>
			</div>
			<div className={styles.ratePoints}>
				{items.map((item) => (
					<div key={item} className={styles.ratePoint}>
						<div className={styles.rateIcon}>
							<ArrowIcon />
						</div>
						<h5>{item}</h5>
					</div>
				))}
			</div>
		</div>
	</div>
)

export const AboutCredit = ({
	title,
	hint,
	rateMode,
	points,
	mainTitle,
	customBannerItems,
	customPercent,
}: Props) => {
	return (
		<div className='pt-l'>
			<h2>{mainTitle || 'О кредите'}</h2>
			<div className={cx(styles.infoBlock, !hint && styles.noColumns)}>
				<h3>{title}</h3>
				{hint && <div className={styles.hint}>{hint}</div>}
			</div>
			<div className={styles.points}>
				{points.map(({ title, IconSvg, text }) => (
					<div className={styles.point} key={title}>
						<div className={styles.icon}>
							<IconSvg />
						</div>
						<div className={styles.pointSummary}>
							<h4>{title}</h4>
							<div className={styles.pointSummaryText}>{text}</div>
						</div>
					</div>
				))}
			</div>
			{customBannerItems ? (
				<CustomCreditRate
					title={<>Ставка от {customPercent} %</>}
					subtitle={
						<>
							Что влияет на величину
							<br />
							процентной ставки
						</>
					}
					items={customBannerItems}
				/>
			) : (
				<>
					{rateMode === 'pledge' && <RatePledge percent={customPercent} />}
					{rateMode === 'car' && <RateCar />}
				</>
			)}
		</div>
	)
}
